// NOTE: 「似た条件」や「関連ボランティア」などの差し込み部分をボタンで横スクロール
function initializeHorizontalScroll() {
  const SCROLL_STEP = 630;
  const slideArrows = document.querySelectorAll(".jsSlideArrow");

  if (slideArrows.length === 0) return;

  slideArrows.forEach((arrow) => {
    arrow.addEventListener("click", () => {
      const recommendBoxId = arrow.dataset.idx;
      const scrollDirection = arrow.dataset.direction;
      const targetBox = document.querySelector(`.jsRecommend${recommendBoxId}`);

      if (!targetBox) return;

      const currentScrollPosition = targetBox.scrollLeft;

      const nextScrollPosition =
        scrollDirection === "left"
          ? currentScrollPosition - SCROLL_STEP
          : currentScrollPosition + SCROLL_STEP;

      targetBox.scrollTo({
        left: nextScrollPosition,
        behavior: "smooth",
      });

      const maxScrollPosition = targetBox.scrollWidth - targetBox.clientWidth;

      const leftArrow = document.querySelector(
        `.jsSlideArrow[data-idx="${recommendBoxId}"][data-direction="left"]`
      );
      const rightArrow = document.querySelector(
        `.jsSlideArrow[data-idx="${recommendBoxId}"][data-direction="right"]`
      );

      if (leftArrow) leftArrow.classList.remove("isDisable");
      if (rightArrow) rightArrow.classList.remove("isDisable");

      if (nextScrollPosition <= 0 && leftArrow)
        leftArrow.classList.add("isDisable");
      if (nextScrollPosition >= maxScrollPosition && rightArrow)
        rightArrow.classList.add("isDisable");
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initializeHorizontalScroll();
});

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default initializeHorizontalScroll;